import styled from 'styled-components';

export const VideoStyle = styled.div`
  display: flex;
  justify-content: center;
`;
